/**
 * 全局状态
 */
const vModal = {
  namespaced: true,
  state: {
    showType: "",
    isCreateFavoriteDialogShow: false,
    openPictureModal:false,
  },
  mutations: {
    //  打开图片详情弹框
    updateOpenPictuerModal(state,isOpen){
      state.openPictureModal = isOpen;
    }
  },
};
export default vModal;
